module.exports = __webpack_public_path__ + "static/FAQ-career1-7791e4414b36be03d51d0583000151ed.jpg";